"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApiClient = createApiClient;
var _constants = require("./constants.cjs");
function createApiClient(http, {
  accessToken,
  headers
}) {
  const defaultHeaders = {
    authorization: `Bearer ${accessToken}`,
    'User-Agent': _constants.DEFAULT_USER_AGENT,
    ...headers
  };
  function get(url, {
    headers,
    query
  } = {}) {
    return http.get(url, {
      headers: {
        ...defaultHeaders,
        ...headers
      },
      query
    });
  }
  function post(url, {
    headers,
    payload,
    query
  } = {}) {
    return http.post(url, {
      headers: {
        ...defaultHeaders,
        ...headers
      },
      payload,
      query
    });
  }
  function put(url, {
    headers,
    payload,
    query
  } = {}) {
    return http.put(url, {
      headers: {
        ...defaultHeaders,
        ...headers
      },
      payload,
      query
    });
  }
  function patch(url, {
    headers,
    payload,
    query
  } = {}) {
    return http.patch(url, {
      headers: {
        ...defaultHeaders,
        ...headers
      },
      payload,
      query
    });
  }
  function doDelete(url, {
    headers,
    payload,
    query
  } = {}) {
    return http.delete(url, {
      headers: {
        ...defaultHeaders,
        ...headers
      },
      payload,
      query
    });
  }
  return {
    get,
    post,
    put,
    patch,
    delete: doDelete
  };
}